import _taggedTemplateLiteral from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/get";
import _createClass from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <style>\n      :host {\n        display: -ms-inline-flexbox;\n        display: -webkit-inline-flex;\n        display: inline-flex;\n        -ms-flex-align: center;\n        -webkit-align-items: center;\n        align-items: center;\n        -ms-flex-pack: center;\n        -webkit-justify-content: center;\n        justify-content: center;\n        position: relative;\n        vertical-align: middle;\n        padding: 8px;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n        cursor: pointer;\n        z-index: 0;\n        line-height: 1;\n        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n        -webkit-tap-highlight-color: transparent;\n        box-sizing: border-box !important;\n      }\n    \n      :host(.pending) {\n        opacity: 0;\n      }\n    \n      :host(.disabled) {\n        opacity: 0.45 !important;\n        cursor: default;\n        background: rgba(0, 0, 0, 0.07);\n        border-radius: 50%;\n        pointer-events: none;\n      }\n    \n      :host(:active) path {\n        transform: scale(0.96) translate(2%, 2%);\n      }\n    \n      .overlay {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        pointer-events: none;\n      }\n    \n      svg {\n        display: block;\n      }\n    \n      path {\n        stroke: currentColor;\n        stroke-width: 0.7;\n        fill: var(--wired-icon-bg-color, transparent);\n        transition: transform 0.05s ease;\n      }\n    \n      mwc-icon {\n        position: relative;\n        font-size: var(--wired-icon-size, 24px);\n      }\n    </style>\n    <div class=\"overlay\">\n      <svg id=\"svg\"></svg>\n    </div>\n    <mwc-icon>\n      <slot></slot>\n    </mwc-icon>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { LitElement, html } from '@polymer/lit-element/lit-element.js';
import { wired } from 'wired-lib/wired-lib.js';
import '@material/mwc-icon';
export var WiredIconButton =
/*#__PURE__*/
function (_LitElement) {
  _inherits(WiredIconButton, _LitElement);

  _createClass(WiredIconButton, null, [{
    key: "properties",
    get: function get() {
      return {
        disabled: Boolean
      };
    }
  }]);

  function WiredIconButton() {
    var _this;

    _classCallCheck(this, WiredIconButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WiredIconButton).call(this));
    _this.disabled = false;
    return _this;
  }

  _createClass(WiredIconButton, [{
    key: "_createRoot",
    value: function _createRoot() {
      var root = this.attachShadow({
        mode: 'open'
      });
      this.classList.add('pending');
      return root;
    }
  }, {
    key: "_render",
    value: function _render() {
      this._onDisableChange();

      return html(_templateObject());
    }
  }, {
    key: "_onDisableChange",
    value: function _onDisableChange() {
      if (this.disabled) {
        this.classList.add("disabled");
      } else {
        this.classList.remove("disabled");
      }

      this._refreshTabIndex();
    }
  }, {
    key: "_refreshTabIndex",
    value: function _refreshTabIndex() {
      this.tabIndex = this.disabled ? -1 : this.getAttribute('tabindex') || 0;
    }
  }, {
    key: "_setAria",
    value: function _setAria() {
      this.setAttribute('role', 'button');
      this.setAttribute('aria-label', this.textContent);
    }
  }, {
    key: "_clearNode",
    value: function _clearNode(node) {
      while (node.hasChildNodes()) {
        node.removeChild(node.lastChild);
      }
    }
  }, {
    key: "_didRender",
    value: function _didRender() {
      var svg = this.shadowRoot.getElementById('svg');

      this._clearNode(svg);

      var s = this.getBoundingClientRect();
      var min = Math.min(s.width, s.height);
      svg.setAttribute("width", min);
      svg.setAttribute("height", min);
      wired.ellipse(svg, min / 2, min / 2, min, min);
      this.classList.remove('pending');

      this._setAria();

      this._attachEvents();
    }
  }, {
    key: "_attachEvents",
    value: function _attachEvents() {
      var _this2 = this;

      if (!this._keyboardAttached) {
        this.addEventListener('keydown', function (event) {
          if (event.keyCode === 13 || event.keyCode === 32) {
            event.preventDefault();

            _this2.click();
          }
        });
        this._keyboardAttached = true;
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;

      _get(_getPrototypeOf(WiredIconButton.prototype), "connectedCallback", this).call(this);

      setTimeout(function () {
        return _this3._didRender();
      });
    }
  }]);

  return WiredIconButton;
}(LitElement);
customElements.define('wired-icon-button', WiredIconButton);